import { afterDamageTaken, defineGameCard } from '../authoring/index.js';
import { slimeDependencies, tableOf, trail } from './slime-helpers.js';
export const BuddingBellyCard = defineGameCard({
    id: 'budding_belly',
    gameplay: { type: 'UNIT', cost: 4, baseStats: { attack: 4, health: 5 }, traits: ['SLIME'] },
    presentation: {
        name: 'Почкующееся брюхо',
        description: 'След 1. Когда получает урон и выживает, теряет 1 базовую атаку и создаёт Каплю 1/1 в свободной ячейке этой локации. При базовой атаке 0 способность не срабатывает.',
        glyph: {
            colors: ['#10213A', '#9C990C', '#C6BF14', '#64660E', '#3A3C19'],
            rows: [
                '......11....11......',
                '.....1221..1321.....',
                '.....14241.1241.....',
                '.....14551.1441.....',
                '......15422451......',
                '.....1223333241.....',
                '....122233333341....',
                '...12223323223241...',
                '..142233223333321...',
                '..1233333333224321..',
                '..1432343233324241..',
                '..1424323223224451..',
                '..1454422443244541..',
                '...14544445245541...',
                '....144554455541....',
                '.....1144554541.....',
                '.......1144111......',
                '.........11.........',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies('slime_droplet'),
    abilities: [
        trail(),
        afterDamageTaken((ctx, event) => {
            const selfId = ctx.self?.id;
            if (selfId === undefined || event.amount <= 0)
                return;
            const live = ctx.q.instance(selfId);
            if (live?.zone !== 'board' || live.cellId === undefined
                || live.stats.health <= 0 || live.stats.attack <= 0)
                return;
            ctx.ops.modifyStat(live.id, 'attack', -1);
            ctx.ops.createTokenInLocation('slime_droplet', live.controllerId, tableOf(live.cellId));
        }),
    ],
    ui: { mechanics: ['token', 'trail', 'slime_residue'] },
});
//# sourceMappingURL=budding_belly.js.map